
export default
  props:
    id:
      type:Number
      default:0

  components : {}
